// extracted by mini-css-extract-plugin
module.exports = {"modal":"reviewEventModal_modal__1zVnl","cardWrapper":"reviewEventModal_cardWrapper__3E4B8","iconStyle":"reviewEventModal_iconStyle__1z668"};